module.exports = __webpack_public_path__ + "static/media/renovation.a03a5816.png";